export type SLOStatus = 'meets' | 'neither' | 'breaches';
export type SLOQualityStatus = 'healthy' | 'neither' | 'unhealthy';
export enum SLOLifecycleStatus {
  DRAFT,
  COMMITTED,
  SNAPSHOT,
}
